import React from 'react';
import loadingGif from '../../assets/images/loading.gif';

const LoadingUI = () => {
  return (
    <img src={loadingGif} alt='loading.gif' style={{ width: '100px', height: 'auto' }} />
  );
};

export default LoadingUI;
